import React from 'react';
import './AppSeparator.css';
import {Institution} from "../services/types/apitypes";
import {IonIcon} from "@ionic/react";

export default function InstitutionBox({institution, hideAddress, onClick}: {institution: Institution, hideAddress?: boolean, onClick?: () => void}) {
    return (
        <div style={{
            background: 'white',
            display: 'flex',
            flexFlow: 'column',
            padding: '1rem 1.2rem',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            position: 'relative',
        }}
             onClick={onClick}
        >
            {onClick && hideAddress && <div style={{position: "absolute", height: "100%", width: "100%", display: "flex", alignItems: "center", transform: "rotate(180deg)", top: 0, left: 0, paddingLeft: "0.5rem"}}>
                <IonIcon style={{color: "black", stroke:"black", fill:"black"}} src="assets/icon/caret-left-black.svg"></IonIcon></div>}
            <div style={{
                display: 'flex',
                flexFlow: 'column',
                padding: '1rem 0',
                borderBottom: hideAddress ? 'none': '1px solid #ccc',
                gap: "0.5rem",
            }}>
                <span style={{"fontWeight": "bold"}}>{institution.name}</span>
                <span>Type: {institution.institutionType}</span>
            </div>
            {!hideAddress &&
                <div style={{
                    background: 'white',
                    display: 'flex',
                    flexFlow: 'column',
                    padding: '1rem 0',
                    borderRadius: '8px'
                }}>
                    {institution.institutionAddress && <>
                        <span>{institution.institutionAddress.street}{institution.institutionAddress.street_optional ? ' ' + institution.institutionAddress.street_optional : ''}, {institution.institutionAddress.city}</span>
                        <span>{institution.institutionAddress.state} {institution.institutionAddress.zip}, {institution.institutionAddress.country}</span>
                        <span style={{"marginTop": "1rem"}}>Phone: {institution.phoneNumber}</span>
                    </>}
                </div>
            }
        </div>
    );
}
